import { agendaConst } from "../constants";

const EXCLUSIVE_FIELDS = [
  'packageId',
  'promoId',
  'purchasedProductId',
  'treatmentId',
  'treatmentsIds',
  'categoriesIds',
  'sessions',
];

const OPTION_ALLOWED_FIELDS = {
  [agendaConst.purchasedProducts]: ['purchasedProductId', 'sessions'],
  [agendaConst.promotion]: ['promoId', 'treatmentId'],
  [agendaConst.packages]: ['packageId', 'treatmentId'],
  [agendaConst.newTreatments]: ['treatmentsIds', 'categoriesIds'],
};

export const normalizeExclusiveFields = (data, optionSelected) => {
  const allowed = OPTION_ALLOWED_FIELDS[optionSelected] ?? [];
  const cleaned = { ...data };

  EXCLUSIVE_FIELDS.forEach((field) => {
    if (!allowed.includes(field)) {
      delete cleaned[field];
    }
  });

  return cleaned;
};

export const mergeWithExistingIfNeeded = ({
  data,
  appointmentById,
  optionSelected,
  letOption,
}) => {
  // Si no hay cita original o el usuario SÍ decidió cambiar la opción,
  // no rellenamos nada: respetamos lo que viene del form.
  if (!appointmentById || letOption) return data;

  const merged = { ...data };

  // Aseguramos appointmentOption
  if (!merged.appointmentOption && appointmentById.appointmentOption) {
    merged.appointmentOption = appointmentById.appointmentOption;
  }

  // treatmentTypeId casi siempre debe mantenerse
  if (
    !merged.treatmentTypeId &&
    appointmentById.treatment?.treatmentType?.id
  ) {
    merged.treatmentTypeId = appointmentById.treatment.treatmentType.id;
  }

  switch (optionSelected) {
    case agendaConst.purchasedProducts:
      if (!merged.purchasedProductId && appointmentById.purchasedProduct?.id) {
        merged.purchasedProductId = appointmentById.purchasedProduct.id;
      }
      break;

    case agendaConst.promotion:
      if (!merged.promoId && appointmentById.pendingProduct?.pkg?.id) {
        merged.promoId = appointmentById.pendingProduct.pkg.id;
      }
      if (!merged.treatmentId && appointmentById.treatment?.id) {
        merged.treatmentId = appointmentById.treatment.id;
      }
      break;

    case agendaConst.packages:
      if (!merged.packageId && appointmentById.pendingProduct?.pkg?.id) {
        merged.packageId = appointmentById.pendingProduct.pkg.id;
      }
      if (!merged.treatmentId && appointmentById.treatment?.id) {
        merged.treatmentId = appointmentById.treatment.id;
      }
      break;

    case agendaConst.newTreatments:
      // Aquí podrías mantener treatmentsIds/categoriesIds si los tuvieras
      break;

    default:
      break;
  }

  return merged;
};